import "./bootstrap-config";
import "./font-awesome-config";
import "./map";
import "./youtube_vimeo";
import "../styles/main.scss";
// Dynamic import for Particles.js
let particleSections = document.getElementsByClassName("particle-background");
if (particleSections.length > 0) {
    import("particles.js").then(() => {
        for (let i = 0; i < particleSections.length; i++) {
            const section = particleSections[i];
            let configFileName = section.dataset.configFile, themeName = section.dataset.name;
            window.particlesJS.load(particleSections[i].id, "/wp-content/themes/" +
                themeName +
                "/particles_configs/" +
                configFileName, function () { });
        }
    });
}
// Uncomment to add Animate on Scroll library
// import AOS from "aos";
// import "aos/dist/aos.css";
// AOS.init();
// Uncomment to add Swiper carousel library
import "./swiper-config";
// Uncomment to add Masonry Layout library
import Masonry from "masonry-layout";
window.addEventListener("load", function () {
    let elem = document.querySelector(".masonry-grid");
    if (elem) {
        let msnry = new Masonry(elem, {
            // options
            itemSelector: ".grid-item",
            columnWidth: ".grid-sizer",
            percentPosition: true,
        });
    }
});
// Uncomment to add Fancybox light box library
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
Fancybox.bind("[data-fancybox]", {
// Your custom options
});
import "./theme";
